import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { fadeInUp, staggerContainer, useParallax } from '../hooks/useScrollAnimation';

const bullets = [
  'ESF covers development and supports your rollout',
  'No IT integration required from your side',
  'Revenue sharing starts from the first transaction',
];

const ZeroRisk = () => {
  const { ref, y } = useParallax(30);

  return (
    <section className="relative py-24 md:py-32 bg-esf-dark overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <motion.div
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: '-100px' }}
          >
            <motion.p variants={fadeInUp} className="text-eyebrow uppercase text-esf-blue mb-4">
              No cost to the club
            </motion.p>
            <motion.h2
              variants={fadeInUp}
              className="text-display-lg text-esf-white text-balance"
            >
              We build it. We run it. You earn.
            </motion.h2>
            <motion.ul variants={fadeInUp} className="mt-8 space-y-5">
              {bullets.map((bullet) => (
                <li key={bullet} className="flex items-start gap-3">
                  <span
                    className="mt-1 flex-shrink-0 w-5 h-5 rounded-full bg-esf-blue/20 flex items-center justify-center"
                    aria-hidden="true"
                  >
                    <Check size={12} className="text-esf-blue" />
                  </span>
                  <span className="text-body-lg text-esf-gray-100">{bullet}</span>
                </li>
              ))}
            </motion.ul>
            <motion.a
              variants={fadeInUp}
              href="#how-it-works"
              className="inline-flex items-center gap-1.5 mt-8 text-esf-blue hover:text-esf-cyan transition-colors font-medium"
            >
              See how it works
              <span aria-hidden="true">&rarr;</span>
            </motion.a>
          </motion.div>

          <div ref={ref} className="relative flex justify-center lg:justify-end">
            <motion.div style={{ y }} className="relative">
              <picture>
                <source srcSet="/esf-admin-macbook.webp" type="image/webp" />
                <img
                  src="/esf-admin-macbook.png"
                  alt="The ESF admin dashboard showing club revenue and transaction activity"
                  width={1400}
                  height={858}
                  loading="lazy"
                  decoding="async"
                  className="w-full max-w-lg h-auto animate-float rounded-lg"
                />
              </picture>
              <div className="absolute -inset-4 bg-esf-blue/5 rounded-2xl blur-2xl -z-10" />
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ZeroRisk;
